import { TIER_CODES, TierCode } from 'types/clientIdentification';
import { getClassifierText, t } from 'utils/getTranslations';
import { useClassifiers } from 'utils/useClassifiers';

export const TIER_CLASSIFIER = 'RISK_ASSESSMENT_LEVEL';

export interface TierOption {
    code: TierCode;
    name: string;
    /** What the tier itself asks; the related-party roles follow the firm's settings and are not named. */
    caption: string;
}

/** The three tiers in their order, named by the level dictionary and captioned by what each one fixes in code. */
export function useTierOptions(): { options: TierOption[]; isLoading: boolean } {
    const { classifiers, isLoading } = useClassifiers({ codes: [TIER_CLASSIFIER] });
    const classifier = classifiers[TIER_CLASSIFIER];
    const options = TIER_CODES.map((code) => ({
        code,
        name: getClassifierText(classifier, code) || code,
        caption: t(`client-identification.tier-caption.${code}`),
    }));
    return { options, isLoading };
}

/** A tier's name, for the page that shows one; the code while the dictionary has not loaded. */
export function useTierName(code: TierCode): string {
    const { classifiers } = useClassifiers({ codes: [TIER_CLASSIFIER] });
    return getClassifierText(classifiers[TIER_CLASSIFIER], code) || code;
}
